/*
 * @Author: wuzhonghai1 wuzhonghai1@jd.com
 * @Date: 2026-04-29 11:41:10
 * @LastEditors: wuzhonghai1 wuzhonghai1@jd.com
 * @LastEditTime: 2026-06-01 17:08:34
 * @FilePath: /isp_International/src/util/commonUtils.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
//是否游客模式
export const isGuest = ()=>{
    const host = window.location.host;
    return host.includes('open') || host.includes('best');
}
